
<div class='selector' style="width:100%">
  <div class='selector-container'>
    <div class='selector-arrow selector-arrow_left' @click='prevDay'></div>
    <div class="selector-txt-container selector-txt-calendar">
      <div class='selector-txt' @click="openMiniCalendar">
        {{ getCurrentDateLinear }}
      </div>
      <el-date-picker ref="picker" v-model="valueMiniCalendar" type="date" placeholder="Pick a day"
        :picker-options="pickerOptions1" @change="miniCalDateChoosed" />
    </div>
    <div class='selector-arrow selector-arrow_right' @click='nextDay'></div>
  </div>
</div>
